import React, { useState, useEffect } from "react";

const AgeVerificationModal: React.FC = () => {
  const [show, setShow] = useState<boolean>(false);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [isRejected, setIsRejected] = useState<boolean>(false);

  console.log("AgeVerificationModal Component Triggered!");

  useEffect(() => {
    const isVerified = localStorage.getItem("isAgeVerified");
    console.log("Current Verification Status in Storage:", isVerified);

    if (isVerified !== "true") {
      console.log("Condition Met: Starting 3-second timer...");

      const timer = setTimeout(() => {
        console.log("Timer Finished: Setting Modal to Visible");
        setIsVisible(true);
        setTimeout(() => setShow(true), 100);
      }, 3000);

      return () => clearTimeout(timer);
    } else {
      console.log("User already verified, modal will not show.");
    }
  }, []);

  const handleYes = () => {
    localStorage.setItem("isAgeVerified", "true");
    setShow(false);
    setTimeout(() => setIsVisible(false), 500);
  };

  const handleNo = () => {
      setIsRejected(true);
      setTimeout(() => {
        window.location.href = "https://www.google.com";
      }, 2500);
  };

  // Jab tak isVisible false hai, modal DOM mein nahi aayega
  if (!isVisible) {
    return null;
  }

  return (
    <div className={`age_verification_overlay ${show ? "show" : ""}`}>
      <div className="age_verification_modal">
        {isRejected ? (
          /* Yeh portion tab dikhega jab user "NO" click karega */
          <div className="error_content">
             <h3 style={{ color: "#dc3545", margin: "0" }}>Access Denied</h3>
             <p style={{ marginTop: "15px", fontWeight: "500" }}>
                Sorry! This platform is only for users 18 years or older.
             </p>
             <small style={{ color: "#888" }}>Redirecting to Google...</small>
          </div>
        ) : (
          <>
            <h2>Age Verification</h2>
            <p>
              You must be <strong>18</strong> years old to enter.
            </p>
            <div className="age_btn_group">
              <button className="age_btn btn_yes" onClick={handleYes}>
                YES
              </button>
              <button className="age_btn btn_no" onClick={handleNo}>
                NO
              </button>
            </div>
          </>
          )}
      </div>
    </div>
  );
};

export default AgeVerificationModal;